import React from "react";
import InterviewUsersTable from "./InterviewUsersTable";
import InterviewUsersMetrics from "./InterviewUsersMetrics";
import "./interviewUsersAnalyticsContent.scss";

const InterviewUsersAnalyticsContent = () => {
  return (
    <div className="interview-users-analytics-content">
      {/* Header */}
      <div className="analytics-header">
        <div>
          <h1 className="analytics-title">Interview Users Analytics</h1>
          <p className="analytics-subtitle">
            Comprehensive view of all interview users performance and statistics
          </p>
        </div>
      </div>

      {/* Metrics Overview */}
      <InterviewUsersMetrics />

      {/* Interview Users Table with integrated filters */}
      <InterviewUsersTable />
    </div>
  );
};

export default InterviewUsersAnalyticsContent;

